import "esbuild-css-modules-plugin-ns-css:src/js/components/categorySelect/categorySelect.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/categorySelect/categorySelect.module.css:injector.js";
export default new Proxy({
  "categoryContainer": "categorySelect-module__categoryContainer_gbkhAa__1100",
  "categoryControl": "categorySelect-module__categoryControl_gbkhAa__1100",
  "categoryHeading": "categorySelect-module__categoryHeading_gbkhAa__1100",
  "categoryHeadingContainer": "categorySelect-module__categoryHeadingContainer_gbkhAa__1100",
  "customCheckbox": "categorySelect-module__customCheckbox_gbkhAa__1100",
  "subCategory": "categorySelect-module__subCategory_gbkhAa__1100",
  "toolTip": "categorySelect-module__toolTip_gbkhAa__1100",
  "toolTipContentBox": "categorySelect-module__toolTipContentBox_gbkhAa__1100",
  "toolTipContentHeading": "categorySelect-module__toolTipContentHeading_gbkhAa__1100",
  "toolTipContentSubheading": "categorySelect-module__toolTipContentSubheading_gbkhAa__1100",
  "toolTipContentText": "categorySelect-module__toolTipContentText_gbkhAa__1100",
  "toolTipIcon": "categorySelect-module__toolTipIcon_gbkhAa__1100",
  "toolTipList": "categorySelect-module__toolTipList_gbkhAa__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      